/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CostflowDto } from '../models/costflow-dto';
import { getEffectiveCostflow } from '../fn/costflow/get-effective-costflow';
import { GetEffectiveCostflow$Params } from '../fn/costflow/get-effective-costflow';
import { getEstimatedCostflow } from '../fn/costflow/get-estimated-costflow';
import { GetEstimatedCostflow$Params } from '../fn/costflow/get-estimated-costflow';

@Injectable({ providedIn: 'root' })
export class CostflowApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEstimatedCostflow()` */
  static readonly GetEstimatedCostflowPath = '/v0/Costflow/estimated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstimatedCostflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedCostflow$Response(params: GetEstimatedCostflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CostflowDto>> {
    return getEstimatedCostflow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEstimatedCostflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedCostflow(params: GetEstimatedCostflow$Params, context?: HttpContext): Observable<CostflowDto> {
    return this.getEstimatedCostflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<CostflowDto>): CostflowDto => r.body)
    );
  }

  /** Path part for operation `getEffectiveCostflow()` */
  static readonly GetEffectiveCostflowPath = '/v0/Costflow/effective';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveCostflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveCostflow$Response(params: GetEffectiveCostflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CostflowDto>> {
    return getEffectiveCostflow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveCostflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveCostflow(params: GetEffectiveCostflow$Params, context?: HttpContext): Observable<CostflowDto> {
    return this.getEffectiveCostflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<CostflowDto>): CostflowDto => r.body)
    );
  }

}
